export const stepConfig = [
  {target: '.LibraryEmptyStateContainer', key: 'libraryOverview'},
  {target: '.UploadButton', key: 'libraryUpload'},
  {target: '.SearchBar', key: 'librarySearch'},
];
